import { OS } from '@/utils/device'

export const getChannel = () => {
  // 从URL中获取channel
  let channel = new URLSearchParams(window.location.search).get('channel')
  // 防止app对#/的解析错误导致渠道错误
  if (channel?.includes('%23%2F')) {
    channel = channel.split('%23%2F')[0]
  } else if (channel?.includes('#/')) {
    channel = channel.split('#/')[0]
  }
  // 获取localStorage中的channel
  const channelStorage = localStorage.getItem('channel_login')

  // localStorage.removeItem('channel_login')  // 清除localStorage中的channel,放在最后，因为很多地方会调用

  // // 如果channel存在，存入localStorage
  // channel &&
  //   localStorage.setItem('channel_login', JSON.stringify({ channel: channel, time: +new Date() }))

  // json化获取的localStorage中的channel数据
  const entryObject =
    channelStorage && channelStorage != 'undefined' && JSON.parse(channelStorage as string)
  // 从url中获取channel，或者localStorage中获取channel，否则默认为'store'
  const channelStr = (channel != 'undefined' && channel) || entryObject?.channel || 'default'
  window.channel = channelStr
  return channelStr
}

export const getClient = () => {
  // client
  const client = new URLSearchParams(window.location.search).get('client')
  const clientDevice =
    ((OS.isVertical || client === 'mobile') && 'mobile') || // 竖屏认为是mobile渠道
    ((OS.isIpad || client === 'ipad') && 'ipad') ||
    ((OS.isAndroid || client === 'android') && 'android') ||
    'pc'
  // 从url中获取client，否则通过设备判断clientDevice  默认为'store'
  const clientStr = (client != 'undefined' && client) || (OS.isNioBrowser && 'pc') || clientDevice // 先读取url中的client，再读取是不是车机（车机固定PC），如果没有再通过设备判断
  window.client = clientStr
  return clientStr
}

export const getAttr = () => {
  // attr
  const attr = new URLSearchParams(window.location.search).get('attr')
  window.attr = attr
  return attr
}

export const isDebugger = () => {
  // isDebugger
  const isDebugger = new URLSearchParams(window.location.search).get('debugger')
  window.attr = isDebugger
  console.log('isDebugger', isDebugger)
  return isDebugger
}
